<template>
  <div class="join-organisation-field-wrapper">
    <checkbox-input v-if="useCheckbox" :checkbox-id="calculatedInputId" :initial-value="preChecked" :input-name="calculatedInputName"
                    :label="label" :show-label="showLabel" :validation-errors="validationErrors" @change="checkboxChange" @focus="$emit('focus')" />
    <input v-if="useHidden" :id="calculatedInputId" type="hidden" :name="calculatedInputName" :value="implicit">
    <radio-buttons-input v-if="useRadio" :label="label" :input-name="calculatedInputName" :options="radioButtonOptions"
                         :initial-value="null" :show-label="showLabel" :validation-errors="validationErrors"
                         @change="checkboxChange" @focus="$emit('focus')" />

    <div v-if="showConfirmationForNo" class="radio-are-you-sure-message alert alert-warning" v-html="radioSureLabel" />

    <input type="hidden" :name="calculatedEmailOptInTypeIdInputName" :value="id">
  </div>
</template>

<script>
import CheckboxInput from './checkbox-input'
import isPresent from '../../helpers/is-present'
import RadioButtonsInput from './radio-buttons-input.vue'
import WithInputIdAndName from '@/components/inputs/mixins/with-input-id-and-name'

export default {
  components: { CheckboxInput, RadioButtonsInput },

  mixins: [ WithInputIdAndName ],

  props: {
    emailOptInTypeData: {
      type: Object,
      required: true
    },

    emailOptInTypeFieldNameOverride: {
      type: String,
      required: false
    },

    entityName: {
      type: String,
      required: true
    },

    label: {
      type: String,
      required: false
    },

    showLabel: {
      type: Boolean,
      required: false,
      default: true
    },

    validationErrors: {
      type: Array,
      required: false
    }
  },

  emits: ['changed', 'focus'],

  data() {
    let initialValue = null
    if (this.emailOptInTypeData.modality === 'checkbox') {
      initialValue = this.emailOptInTypeData.preChecked
    } else if (this.emailOptInTypeData.modality === 'hidden') {
      initialValue = this.emailOptInTypeData.implicit
    }

    return {
      modality: this.emailOptInTypeData.modality,
      fieldName: 'join-organisation',
      id: this.emailOptInTypeData.id,
      implicit: this.emailOptInTypeData.implicit,
      preChecked: this.emailOptInTypeData.preChecked,
      radioButtonYesLabel: this.emailOptInTypeData.radioButtonYesLabel,
      radioButtonNoLabel: this.emailOptInTypeData.radioButtonNoLabel,
      radioSureLabel: this.emailOptInTypeData.radioSureLabel,
      value: initialValue
    }
  },

  computed: {
    calculatedEmailOptInTypeIdInputName() {
      return this.emailOptInTypeFieldNameOverride || `${this.entityName}[email_opt_in_type_id]`
    },

    showValidationError() {
      return this.validationErrors && this.validationErrors.length > 0
    },

    useCheckbox() {
      return this.modality === 'checkbox'
    },

    useHidden() {
      return this.modality === 'hidden'
    },

    useRadio() {
      return this.modality === 'radio'
    },

    radioButtonOptions() {
      return [
        [ this.radioButtonYesLabel, true ],
        [ this.radioButtonNoLabel, false ]
      ]
    },

    showConfirmationForNo() {
      // We need to explicitly compare with false to avoid displaying the message when the user hasn't selected any option yet
      return (this.modality === 'radio' && isPresent(this.radioSureLabel) && this.value === false)
    }
  },

  mounted() {
    // Need to emit so that if the user submits the form without checking/unchecking the box,
    // the parent component will have the correct values for these fields
    this.emitValue(true)
  },

  methods: {
    checkboxChange(value) {
      this.value = value
      this.emitValue(false)
    },

    emitValue(automatedEvent) {
      this.$emit('changed', { emailOptInTypeId: this.id, joinOrganisation: this.value, automatedEvent: automatedEvent })
    }
  }
}
</script>
